import Container from './CategoryFilterContainer';
export default Container;